<template>
    <div ref="root" class="barcode d-inline-block" :style="`height: ${height || '3em'};`">
        <div v-for="(width, index) in widths" :class="'w-' + width + ' ' + (index % 2 === 0 ? 'filled' : '')"></div>
    </div>
</template>

<script>
export default {
    name: 'LoadingBarcode',

    props: {
        height: String,
        bgClass: String
    },

    data() {
        return {
            timeout: 40,
            resetAfter: 400,
            pos: 0,
            lines: [],
            widths: [1,1,1,3,3,1,1,2,1,3,1,3,2,1,1,2,2,1,1,2,1,3,1,1,3,1,1,1,1,1,3,1,1,3,1,1,1,4,1,2,1,2,3,2,1,2,3,1,3,3,1,1,1,]
        };
    },

    mounted() {
        this.lines = this.$refs.root.getElementsByClassName('filled');
        this.next();
    },

    methods: {
        next() {
            let e = this.lines[this.pos];
            e.classList.add(this.bgClass);

            setTimeout(() => {
                e.classList.remove(this.bgClass);
            }, this.resetAfter);

            if (++this.pos >= this.lines.length) this.pos = 0;
            setTimeout(this.next, this.timeout);
        },
    },
};
</script>

<style>
.barcode div {
    float: left;
    height: 100%;
}

.filled {
    background-color: #646c9a;
    transition: 0.2s;
}

.w-1 {
    width: 2px;
}

.w-2 {
    width: 3px;
}

.w-3 {
    width: 5px;
}

.w-4 {
    width: 6px;
}
</style>
